export default __webpack_public_path__ + "static/media/Yousef.2aca8506.jpg";